import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useSearchPageProductOrParsedSearchString } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/useSearchPageProductOrParsedSearchString";

export const useSearchPageShouldShowHeaderHelmet = () => {
  const isLoggedInRetailer = useIsLoggedInRetailer();
  const productOrParsedSearchString =
    useSearchPageProductOrParsedSearchString();

  return !isLoggedInRetailer && !!productOrParsedSearchString;
};
